import React, { useEffect, useState } from 'react';
import {Col,Button,Form, Row} from 'react-bootstrap';
import { Formik } from 'formik';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import { GetHolidays, GetSightseeingList } from '../../../entities/action/action';

const AddItinerary = ()=>{
    const [currentPoints,updateCurrentPoints] = useState(1);
    const [arrPoints,updateArrPoints] = useState([1]);
    const [currentPoints1,updateCurrentPoints1] = useState(1);
    const [arrPoints1,updateArrPoints1] = useState([1]);
    const [arrPoints2,updateArrPoints2] = useState([1]);
    const [day,updateDay] = useState(1);
    const [holidays, updateHolidays] = useState([]);
    const [sightseeing, updateSightseeing] = useState([]);
    
     useEffect(() => {
        (async () => {
          let res = await GetSightseeingList();
          console.log(res);
          if (res?.success) {
            updateSightseeing(res?.sightSeeings);
          }
        })();
    }, []);
    
      useEffect(() => {
        (async () => {
            let arr = await GetHolidays();
            if (arr?.success) {
                updateHolidays(arr?.holidays);
            }
        })();
    }, []);

    useEffect(()=>{
        if(day>=1){
            let temp = [];
            for(let i=0;i<day;i++){
                temp.push(i);
            }
            updateArrPoints2(temp);
        }
    },[day])
    const handleAdd = (type)=>{
        if(type===1){
            const newCurrentPoint = currentPoints+1;
            updateCurrentPoints(newCurrentPoint);
            updateArrPoints([...arrPoints,newCurrentPoint]);
        }else{
            const newCurrentPoint1 = currentPoints1+1;
            updateCurrentPoints1(newCurrentPoint1);
            updateArrPoints1([...arrPoints1,newCurrentPoint1]);
        }
    }
    const handleRemove = (type)=>{
        if(type===1&&currentPoints>1){
            const newCurrentPoint = currentPoints-1;
            updateCurrentPoints(newCurrentPoint);
            let arr = [...arrPoints];
            arr.pop();
            updateArrPoints(arr);
        }else if(type===2&&currentPoints1>1){
            const newCurrentPoint1 = currentPoints1-1;
            updateCurrentPoints1(newCurrentPoint1);
            let arr = [...arrPoints1];
            arr.pop();
            updateArrPoints1(arr);
        }
    }
    return(
        <div className={classes.Box}> 
        <Formik
            initialValues={{}}
            onSubmit={
                async(values,{setSubmitting,resetForm})=>{
                    const dataSet = {
                        ...values,
                        day,
                        night: (day - 1) < 0 ? 0 : day - 1,
                        flightsIncluded: values.flightsIncluded === 'Yes' || values.flightsIncluded === true,
                        flightsNote: values.flightsNote || '',
                    }
                    const token = localStorage.getItem('token');
                    const authHeader = `Bearer ${token}`
                    const res = await fetch("https://api.zupptravel.com/api/v1/itinerary/add", {
                        method: "post",
                        headers: {
                        "Content-Type": "application/json",
                        'Authorization': authHeader
                        },
                        body: JSON.stringify(dataSet),
                    });

                    const json = await res.json();
                    console.log("jsonnnnnnnnnn", json);
                    if (json?.success) {
                        alert("Added Itinerary!");
                        window.location.reload();
                    } else {
                        alert("Error! Please try again later");
                    }
                }
            }
            >
                {
                            ({values,handleChange,handleBlur,handleSubmit})=>(
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group controlId="formBasicAddress" as={Row}>
                                            <Form.Label column sm="2">
                                              Itinerary Name:
                                            </Form.Label>
                                            <Col sm="10">
                                              <Form.Control
                                                type="text"
                                                placeholder="Enter Itinerary Name"
                                                name="itineraryName"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.itineraryName}
                                              />
                                            </Col>
                                        </Form.Group>    
                                        <Form.Group controlId="formBasicAddress" as={Row}>
                                            <Form.Label column sm="2">Holiday ID:</Form.Label>
                                            <Col sm="4"> 
                                                <Form.Control 
                                                    as="select" 
                                                    placeholder="Holiday ID" 
                                                    name="holidayId"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.holidayId}
                                                    required>
                                                        <option value="">--select--</option>
                                                        {holidays?.map((item) => 
                                                            <option value={item.id}>
                                                                {item.name}
                                                                </option>
                                                        )}
                                                </Form.Control>
                                            </Col>
                                                <Form.Label column sm="2">
                                                  Holiday Route:
                                                </Form.Label>
                                                <Col sm="4">
                                                  <Form.Control
                                                    type="text"
                                                    placeholder="Enter Holiday Route"
                                                    name="route"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values?.route}
                                                  />
                                                </Col>
                                        </Form.Group>    
                                        <Form.Group controlId="formBasicOffer" as={Row}>
                                            <Form.Label column sm="2">
                                              Offer:
                                            </Form.Label>
                                            <Col sm="4">
                                              <Form.Control
                                                type="text"
                                                placeholder="Offer"
                                                name="offer"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.offer}
                                              />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group controlId="formBasicPricing" as={Row}>
                                            <Form.Label column sm="12" style={{fontWeight: 'bold', marginBottom: '10px'}}>
                                              Pricing (Share Options):
                                            </Form.Label>
                                        </Form.Group>
                                        <Form.Group controlId="formBasicAdultShares" as={Row}>
                                            <Form.Label column sm="2">Adult Single Share:</Form.Label>
                                            <Col sm="3"> 
                                            <Form.Control
                                                type="number"
                                                placeholder="Adult Single Share"
                                                name="adultSingleShare"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.adultSingleShare}
                                                min={0}
                                              />
                                            </Col>
                                            <Form.Label column sm="2">Adult Double Share:</Form.Label>
                                            <Col sm="3"> 
                                            <Form.Control
                                                type="number"
                                                placeholder="Adult Double Share"
                                                name="adultDoubleShare"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.adultDoubleShare}
                                                min={0}
                                              />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group controlId="formBasicAdultTriple" as={Row}>
                                            <Form.Label column sm="2">Adult Triple Share:</Form.Label>
                                            <Col sm="3"> 
                                            <Form.Control
                                                type="number"
                                                placeholder="Adult Triple Share"
                                                name="adultTripleShare"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.adultTripleShare}
                                                min={0}
                                              />
                                            </Col>
                                            <Form.Label column sm="2">Child Single Share:</Form.Label>
                                            <Col sm="3"> 
                                            <Form.Control
                                                type="number"
                                                placeholder="Child Single Share"
                                                name="childSingleShare"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.childSingleShare}
                                                min={0}
                                              />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group controlId="formBasicChildShares" as={Row}>
                                            <Form.Label column sm="2">Child Double Share:</Form.Label>
                                            <Col sm="3"> 
                                            <Form.Control
                                                type="number"
                                                placeholder="Child Double Share"
                                                name="childDoubleShare"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.childDoubleShare}
                                                min={0}
                                              />
                                            </Col>
                                            <Form.Label column sm="2">Child Triple Share:</Form.Label>
                                            <Col sm="3"> 
                                            <Form.Control
                                                type="number"
                                                placeholder="Child Triple Share"
                                                name="childTripleShare"
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values?.childTripleShare}
                                                min={0}
                                              />
                                            </Col>
                                        </Form.Group>
                                        <Form.Group controlId="formBasicFlights" as={Row}>
                                            <Form.Label column sm="2">Flights Included:</Form.Label>
                                            <Col sm="3">
                                                <Form.Control
                                                    as="select"
                                                    name="flightsIncluded"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values?.flightsIncluded}
                                                    required
                                                >
                                                    <option value="">--select--</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </Form.Control>
                                            </Col>
                                            <Form.Label column sm="2">Flights Note:</Form.Label>
                                            <Col sm="5">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="e.g. Round-trip economy from Delhi, or land package only"
                                                    name="flightsNote"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values?.flightsNote}
                                                />
                                            </Col>
                                        </Form.Group>                                      
                                        <Form.Group controlId="formBasicDay" as={Row}>
                                            <Form.Label column sm="2">Enter Day:</Form.Label>
                                            <Col sm="4"> 
                                                <Form.Control
                                                type="text"
                                                min={1}
                                                placeholder="Enter Day" 
                                                name="day"
                                                onChange={(e)=>updateDay(Number(e.target.value))}
                                                onBlur={handleBlur}
                                                value={day}
                                                required/>
                                            </Col>
                                            <Form.Label column sm="2">Night:</Form.Label>
                                            <Col sm="4"> 
                                                <Form.Control
                                                readOnly
                                                name="night"
                                                value={(day-1)<0?0:day-1}
                                                />
                                            </Col>
                                        </Form.Group>
                                        {
                                            arrPoints2.map((_,key)=>
                                            <div style={{backgroundColor:'whitesmoke',padding:'10px',margin:'5px 0'}}> 
                                            <center><h3>Day {key+1}</h3></center>
                                            <hr/>
                                            <Form.Group controlId="formBasicDayBriefing" as={Row}>
                                                <Form.Label column sm="3">Day Briefing:</Form.Label>
                                                <Col sm="9"> 
                                                    <Form.Control 
                                                        type="text" 
                                                        placeholder="Day Briefing"
                                                        name={`daysRequests[${key}].dayBriefing`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.daysRequests?.[key]?.dayBriefing}
                                                        required/>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group controlId="formBasicDayDescription" as={Row}>
                                                <Form.Label column sm="3">Day Description:</Form.Label>
                                                <Col sm="9"> 
                                                    <Form.Control 
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="Day Description"
                                                        name={`daysRequests[${key}].dayDescription`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.daysRequests?.[key]?.dayDescription}
                                                    />
                                                </Col>
                                            </Form.Group>
                                            {
                                               key==0? 
                                               <>
                                                <Form.Group controlId="formBasicPickupFromHome" as={Row}>
                                                    <Form.Label column sm="3">Pickup Home:</Form.Label>
                                                    <Col sm="3"> 
                                                        <Form.Control 
                                                            as="select" 
                                                            name={`daysRequests[${key}].pickupFromHome`}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.daysRequests?.[key]?.pickupFromHome}
                                                            required>
                                                                <option value="">--select--</option>
                                                                <option value="Yes">Yes</option>
                                                                <option value="No">No</option>
                                                        </Form.Control>
                                                    </Col>
                                                    {
                                                        values?.daysRequests?.[key]?.pickupFromHome==="Yes"?
                                                        <>
                                                            <Form.Label column sm="3">Dropoff Point:</Form.Label>
                                                            <Col sm="3"> 
                                                                <Form.Control 
                                                                    type="text"
                                                                    placeholder="Dropoff Point"
                                                                    name={`daysRequests[${key}].homePickUp`}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                    value={values?.daysRequests?.[key]?.homePickUp}
                                                                    required/>
                                                            </Col>
                                                        </>:null
                                                    }
                                                </Form.Group> 
                                               </>:key===arrPoints2.length-1?
                                               <>
                                               <Form.Group controlId="formBasicPickup" as={Row}>
                                                   <Form.Label column sm="3">Pickup:</Form.Label>
                                                   <Col sm="3"> 
                                                       <Form.Control 
                                                           as="select" 
                                                           name={`daysRequests[${key}].pickup`}
                                                           onChange={handleChange}
                                                           onBlur={handleBlur}
                                                           value={values?.daysRequests?.[key]?.pickup}
                                                           required>
                                                               <option value="">--select--</option>
                                                               <option value="Yes">Yes</option>
                                                               <option value="No">No</option>
                                                       </Form.Control>
                                                   </Col>
                                                   {
                                                       values?.daysRequests?.[key]?.pickup==="Yes"?
                                                       <>
                                                           <Col sm="3"> 
                                                               <Form.Control 
                                                                   type="text"
                                                                   placeholder="Pickup Depot"
                                                                   name={`daysRequests[${key}].homePickUp`}
                                                                   onChange={handleChange}
                                                                   onBlur={handleBlur}
                                                                   value={values?.daysRequests?.[key]?.homePickUp}
                                                                   required/>
                                                           </Col>
                                                       </>:null
                                                   }
                                               </Form.Group> 
                                              </>:null
                                            }
                                            <Form.Group controlId="formBasicTravel" as={Row}>
                                                <Form.Label column sm="3">Inter Cities Travel By:</Form.Label>
                                                <Col sm="9"> 
                                                    <Form.Control 
                                                        type="text" 
                                                        placeholder="Inter Cities Travel By"
                                                        name={`daysRequests[${key}].interCitiesTravelBy`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.daysRequests?.[key]?.interCitiesTravelBy}
                                                        required/>
                                                </Col>
                                            </Form.Group>
                                                <Form.Group controlId="formBasicAccommodationType" as={Row}>
                                                    <Form.Label column sm="3">Accommodation Type:</Form.Label>
                                                    <Col sm="9"> 
                                                        <Form.Control 
                                                            type="text" 
                                                            name={`daysRequests[${key}].accommodationType`}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.daysRequests?.[key]?.accommodationType}
                                                            required/>
                                                    </Col>
                                                </Form.Group> 
                                            <Form.Group controlId="formBasicSightseeingVehicle" as={Row}>
                                                <Form.Label column sm="3">Sightseeing Vehicle:</Form.Label>
                                                <Col sm="9"> 
                                                    <Form.Control 
                                                        type="text" 
                                                        placeholder="Sightseeing Vehicle"
                                                        name={`daysRequests[${key}].sightSeeingVehicle`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.daysRequests?.[key]?.sightSeeingVehicle}
                                                        required/>
                                                </Col>
                                            </Form.Group>
                                            <Form.Group controlId="formBasicAccommodationType" as={Row}>
                                                <Form.Label column sm="3">Lunch:</Form.Label>
                                                <Col> 
                                                    <Form.Control 
                                                        as="select" 
                                                        name={`daysRequests[${key}].lunch`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.daysRequests?.[key]?.lunch}
                                                        required>
                                                            <option value="">--select--</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                    </Form.Control>
                                                </Col> 
                                                <Col> 
                                                    <Form.Control 
                                                        type="number"
                                                        placeholder="Lunch Cost" 
                                                        disabled={values?.daysRequests?.[key]?.lunch=="Yes"?false:true}
                                                        min={0}
                                                        step={0.01}
                                                        name={`daysRequests[${key}].lunchCost`}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values?.daysRequests?.[key]?.lunchCost}
                                                        required/>
                                                </Col> 
                                            </Form.Group>
                                            <Form.Group controlId="formBasicDinnerType" as={Row}>
                                                {
                                                key!=arrPoints2.length-1?
                                                    <>
                                                        <Form.Label column sm="3">Dinner( if Outside ):</Form.Label>
                                                        <Col> 
                                                            <Form.Control 
                                                                as="select" 
                                                                name={`daysRequests[${key}].dinner`}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values?.daysRequests?.[key]?.dinner}
                                                                required>
                                                                    <option value="">--select--</option>
                                                                    <option value="Yes">Yes</option>
                                                                    <option value="No">No</option>
                                                            </Form.Control>
                                                        </Col>
                                                        <Col> 
                                                            <Form.Control 
                                                                type="number"
                                                                placeholder="Dinner Cost" 
                                                                disabled={values?.daysRequests?.[key]?.dinner=="Yes"?false:true}
                                                                min={0}
                                                                step={0.01}
                                                                name={`daysRequests[${key}].dinnerCost`}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                value={values?.daysRequests?.[key]?.dinnerCost}
                                                                required/>
                                                        </Col> 
                                                    </>:null 
                                                } 
                                            </Form.Group> 
                                            {
                                               arrPoints.length>0?arrPoints.map((d,sightseeingKey)=>
                                                <Form.Group controlId={`formselectSightseeing${d}`} key={sightseeingKey} as={Row}>
                                                    <Form.Label column sm="3">Sightseeing {d}:</Form.Label>
                                                    <Col sm="9"> 
                                                        <Form.Control 
                                                            as="select" 
                                                            name={`daysRequests[${key}].sightSeeings[${sightseeingKey}].sightSeeingId`}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values?.daysRequests?.[key]?.sightSeeings?.[sightseeingKey]?.sightSeeingId}
                                                            required>
                                                                <option value="">--select--</option>
                                                                {sightseeing?.map((item) => 
                                                                    <option value={item.id}>
                                                                        {item.sightSeeingName}
                                                                        </option>
                                                                )}
                                                        </Form.Control>
                                                    </Col>
                                                </Form.Group>
                                               ):null 
                                            }
                                            <div style={{display:'flex',justifyContent:'flex-end',marginBottom:'15px'}}>
                                                <Button 
                                                    variant="danger" 
                                                    style={{marginRight:'15px'}} 
                                                    disabled={currentPoints<=1?true:false}
                                                    onClick={()=>handleRemove(1)}
                                                >Remove</Button>
                                                <Button variant="success" onClick={()=>handleAdd(1)}>Add</Button>
                                            </div> 
                                            {
                                               arrPoints1.length>0?arrPoints1.map((d,activityKey)=>
                                                <Form.Group controlId={`formactivities${d}`} key={activityKey} as={Row}>
                                                    <Form.Label column sm="3">Activities {d}:</Form.Label>
                                                    <Col sm="3"> 
                                                        <Form.Control 
                                                            type="text" 
                                                            placeholder='Activities'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            name={`daysRequests[${key}].activities[${activityKey}].activities`}
                                                            value={values?.daysRequests?.[key]?.activities?.[activityKey]?.activities}
                                                            required/>
                                                    </Col>
                                                    <Form.Label column sm="3">Duration {d}:</Form.Label>
                                                    <Col sm="3"> 
                                                        <Form.Control 
                                                            type="text"
                                                            placeholder='Duration'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            name={`daysRequests[${key}].activities[${activityKey}].duration`}
                                                            value={values?.daysRequests?.[key]?.activities?.[activityKey]?.duration}
                                                            required/>
                                                    </Col>
                                                </Form.Group>
                                               ):null 
                                            }
                                            <div style={{display:'flex',justifyContent:'flex-end',marginBottom:'15px'}}>
                                                <Button 
                                                    variant="danger" 
                                                    style={{marginRight:'15px'}} 
                                                    disabled={currentPoints1<=1?true:false}
                                                    onClick={()=>handleRemove(2)}
                                                >Remove</Button>
                                                <Button variant="success" onClick={()=>handleAdd(2)}>Add</Button>
                                            </div> 
                                            <hr/>
                                            </div>
                                            )
                                        }
                                        <center>
                                            <Button type="submit" variant="success">Save Itinerary</Button>
                                        </center>
                                    </Form>
                            )}
                        </Formik>
                    </div>            
    )
}
export default AddItinerary;